import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppState, Selectors } from 'store/root-reducer';
import { Domain } from 'modules/shared/models/domain.models';

@Component({
  selector: 'artemis-select-domain-popup',
  templateUrl: './select-domain-popup.component.html',
  styleUrls: ['./select-domain-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectDomainPopupComponent implements OnInit, OnDestroy {

  private unsubscribe: Subject<any> = new Subject();

  domains: Array<Domain>;
  currentDomain: Domain;

  constructor(private store: Store<AppState>,
              private dialogRef: MatDialogRef<any>,
              private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    combineLatest([
      this.store.select(Selectors.domain.getDomains),
      this.store.select(Selectors.domain.getCurrentDomain)
    ])
    .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        ([domains, currentDomain]: [Array<Domain>, Domain]) => {
          if (domains && currentDomain) {
            this.currentDomain = domains.find((domain: Domain) => domain.id === currentDomain.id);
            this.domains = domains;
            this.cdRef.detectChanges();
          }
        }
      );
  }

  confirm(): void {
    this.dialogRef.close(this.currentDomain);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
